import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponse, ICommonResponseObject } from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import { IPerformanceLesson, IStudentPerformanceResponse } from '../types';
import { GET_STUDENT_PERFORMANCE_LESSONS_OLD, GET_STUDENT_PERFORMANCE_OLD } from './actions';

export type StudentPerformanceOldState = ICommonResponseObject<IStudentPerformanceResponse>;
export type StudentPerformanceLessonsOldState = ICommonResponse<IPerformanceLesson>;

const performanceInitialState: StudentPerformanceOldState = {
  content: {
    year: [],
  },
  loading: false,
  requestCache: 'notCached',
};

const performanceLessonsInitialState: StudentPerformanceLessonsOldState = {
  content: [],
  loading: false,
  requestCache: 'notCached',
};
const genericPerfomance = genericReducers<StudentPerformanceOldState>();
const studentPerformanceReducers: IReducers<StudentPerformanceOldState> = {
  [GET_STUDENT_PERFORMANCE_OLD[REQUEST]]: genericPerfomance.get.request,
  [GET_STUDENT_PERFORMANCE_OLD[SUCCESS]]: genericPerfomance.get.success,
  [GET_STUDENT_PERFORMANCE_OLD[FAILURE]]: genericPerfomance.get.failure,
  [GET_STUDENT_PERFORMANCE_OLD[INVALIDATE]]: genericPerfomance.get.invalidate(performanceInitialState),
};
const genericLessons = genericReducers<StudentPerformanceLessonsOldState>();
const studentPerformanceLessonsReducers: IReducers<StudentPerformanceLessonsOldState> = {
  [GET_STUDENT_PERFORMANCE_LESSONS_OLD[REQUEST]]: genericLessons.get.request,
  [GET_STUDENT_PERFORMANCE_LESSONS_OLD[SUCCESS]]: genericLessons.get.success,
  [GET_STUDENT_PERFORMANCE_LESSONS_OLD[FAILURE]]: genericLessons.get.failure,
  [GET_STUDENT_PERFORMANCE_LESSONS_OLD[INVALIDATE]]: genericLessons.get.invalidate(performanceLessonsInitialState),
};

const studentPerformanceOld = connectReducers(performanceInitialState, studentPerformanceReducers);
const studentPerformanceLessonsOld = connectReducers(performanceLessonsInitialState, studentPerformanceLessonsReducers);

export const collection = {
  studentPerformanceOld,
  studentPerformanceLessonsOld,
};
